var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4863 13.8898L10.9233 3.0057C10.6647 2.57692 10.1931 2.31055 9.69237 2.31055C9.19165 2.31055 8.72 2.57692 8.4614 3.00573L1.89849 13.8898C1.63127 14.333 1.62337 14.8883 1.87783 15.3389C2.13237 15.7895 2.61193 16.0695 3.12943 16.0695H16.2553C16.7728 16.0695 17.2524 15.7895 17.5069 15.3389C17.7614 14.8882 17.7535 14.333 17.4863 13.8898ZM16.5999 14.8266C16.5298 14.9507 16.3978 15.0278 16.2553 15.0278H3.12943C2.98696 15.0278 2.85493 14.9507 2.7849 14.8267C2.71483 14.7026 2.71702 14.5497 2.79055 14.4278L9.35353 3.54364C9.42472 3.42561 9.55456 3.35227 9.6924 3.35227C9.83021 3.35227 9.96006 3.42561 10.0312 3.54364L16.5942 14.4278C16.6678 14.5498 16.6699 14.7026 16.5999 14.8266Z",
    fill: "#C20000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70659 12.2314C9.28137 12.2314 8.9624 12.5697 8.9624 12.9756C8.9624 13.3719 9.28134 13.7198 9.70659 13.7198C10.1028 13.7198 10.4411 13.3719 10.4411 12.9756C10.4411 12.5697 10.1028 12.2314 9.70659 12.2314Z",
    fill: "#C20000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6972 6.59619C9.30095 6.59619 8.9917 6.80882 8.9917 7.18575C8.9917 8.33582 9.12698 9.98844 9.12698 11.1385C9.12701 11.4381 9.38798 11.5638 9.69723 11.5638C9.92917 11.5638 10.2578 11.4381 10.2578 11.1385C10.2578 9.98847 10.393 8.33585 10.393 7.18575C10.393 6.80885 10.0741 6.59619 9.6972 6.59619Z",
    fill: "#C20000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.650b31c236931902e3db9f455836a63e.svg";
export { ForwardRef as ReactComponent };